/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.searchModule')

  .controller('SearchFormController', ['$log', '$rootScope', '$state', '$window', 'BulbAuthService', 'BulbBrowserService', 'BulbErrorService', 'BulbSearchService', 'SEARCH', SearchFormController]);

function SearchFormController($log, $rootScope, $state, $window, BulbAuthService, BulbBrowserService, BulbErrorService, BulbSearchService, SEARCH) {
  var that = this;

  // User's "typed so far" query input value, from which suggestions are generated.
  this.prefix = '';

  // Currently displayed suggestions.
  this.suggestions = [];

  // The currently active suggestion, if any, from which the value of the query input is set.
  this.activeSuggestion = '';

  this.includeOnlyCurrentPortfolio = false;
  this.includeOnlyCurrentOrganizations = false;
  this.isAuthenticated = BulbAuthService.currentUser.isAuthenticated();

  // Search query, this.query, is defined by the model.

  /*
  * Clear the search results by just removing the query typed in the search box and also clear the previous suggestions.
  */
  this.clearSearchResults = function () {

    that.suggestions = [];
    this.query = '';
  };

  /**
   * onchange function for search input: Update suggestions based on prefix.
   * @param prefix The search query, as typed so far.
   */
  this.suggest = function (prefix) {
    this.prefix = (prefix ? prefix.trim() : '');
    if (this.prefix && this.prefix.length >= SEARCH.MIN_PREFIX_LENGTH) {
      BulbSearchService.suggest(this.prefix).then(function (suggestions) {
        that.suggestions = suggestions;
        that.activeSuggestion = '';
      }, function(error) {
        BulbErrorService.error('Cannot get suggestions', error);
        that.suggestions = [];
        that.activeSuggestion = '';
      });
    } else {
      that.suggestions = [];
      that.activeSuggestion = '';
    }
  };

  /**
   * Return the prefix of the input suggestion that matched the user-input prefix.
   * @param suggestion The suggestion that the prefix matched.
   * @returns The prefix of the suggestion that matched the user-input prefix.
   */
  this.getPrefix = function (suggestion) {
    return suggestion.substring(0, this.prefix.length);
  };

  /**
   * Return the rest of the input suggestion,
   * starting after the prefix of the input suggestion that matched the user-input prefix.
   * @param suggestion The suggestion that the prefix matched.
   * @returns The part of the suggestion after the part that matched the user-input prefix.
   */
  this.stripPrefix = function (suggestion) {
    return suggestion.substring(this.prefix.length);
  };

  // Private function to get the index into the suggestions array of the input suggestion.
  // If not found, returns -1.
  function getSuggestionIndex(suggestion) {
    var index = -1;
    if (suggestion) {
      for (var i = 0; i < that.suggestions.length; i += 1) {
        if (suggestion === that.suggestions[i]) {
          index = i;
          break;
        }
      }
    }
    return index;
  }

  // Private function to return a suggestion adjacent to the current active suggestion.
  // If increment is +1, return the next suggestion; if increment is -1, return the previous suggestion.
  // If the current active suggestion is not set,
  // if increment is +1, return the first suggestion; if increment is -1, return the last suggestion.
  function incrementActiveSuggestion(increment) {
    var index = getSuggestionIndex(that.activeSuggestion);
    index += increment;
    if (index < 0) {
      index = that.suggestions.length - 1;
    } else if (index > that.suggestions.length - 1) {
      index = 0;
    }
    that.activeSuggestion = that.suggestions[index] || '';
  }

  /**
   * Set the active suggestion.
   * @param suggestion The input suggestion.
   */
  this.setActiveSuggestion = function (suggestion) {
    var index = getSuggestionIndex(suggestion);
    if (index >= 0) {
      this.activeSuggestion = suggestion;
      this.query = suggestion;
    }
  };

  /**
   * onkeydown function for the query input.
   * Navigates among the displayed suggestions, setting the query input as appropriate.
   * @param event The keydown event.
   */
  this.key = function (event) {
    switch (event.keyCode) {
      case 9: // tab
        event.preventDefault();
        incrementActiveSuggestion(event.shiftKey ? -1 : 1);
        if (this.activeSuggestion) {
          this.query = this.activeSuggestion;
        }
        break;
      case 27: // escape
        event.preventDefault();
        if (this.query === this.prefix) {
          // clear query and suggestions
          this.activeSuggestion = '';
          this.prefix = null;
          this.query = null;
          this.suggestions = [];
        } else {
          // clear active suggestion
          this.activeSuggestion = '';
          this.query = this.prefix;
        }
        break;
      case 40: // down arrow
        event.preventDefault();
        incrementActiveSuggestion(1);
        if (this.activeSuggestion) {
          this.query = this.activeSuggestion;
        }
        break;
      case 38: // up arrow
        event.preventDefault();
        incrementActiveSuggestion(-1);
        if (this.activeSuggestion) {
          this.query = this.activeSuggestion;
        }
        break;
    }
  };

  /**
   * Submit function for the search form.
   * Execute the search, with the query from the query input.
   */
  this.submit = function () {
    this.suggestions = [];
    var scope = 'ALL';
    if (this.includeOnlyCurrentPortfolio === true) {
      scope = 'PORTFOLIO';
    } else if (this.includeOnlyCurrentOrganizations === true) {
      scope = 'ORGANIZATIONS';
    }
    $state.go('searchresults', {
      query: this.query,
      userUnitId: this.includeOnlyCurrentPortfolio === true ? $rootScope.protofolioUserId : null,
      scope: scope,
    }, {
      reload: true
    });
  };

  /**
   * Handle on click for include only radio.
   */
  this.changeOnlyCurrentPortfolio = function () {
    this.includeOnlyCurrentPortfolio = !this.includeOnlyCurrentPortfolio;
    if (this.includeOnlyCurrentPortfolio) {
      this.includeOnlyCurrentOrganizations = false;
    }
  };

  /**
   * Handle on click for include only organization radio.
   */
  this.changeOnlyCurrentOrganizations = function () {
    this.includeOnlyCurrentOrganizations = !this.includeOnlyCurrentOrganizations;
    if (this.includeOnlyCurrentOrganizations) {
      this.includeOnlyCurrentPortfolio = false;
    }
  };

  // If state is searchresults, set the search query, and clear suggestions.
  if ($state.current.name === SEARCH.SEARCH_RESULTS_STATE) {
    this.query = $state.params.query;
    this.includeOnlyCurrentPortfolio = false;
    this.includeOnlyCurrentOrganizations = false;
    this.suggestions = [];
    this.activeSuggestion = '';
  }
  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
    if (toState.name === 'searchresults') {
      that.query = toParams.query;
      that.includeOnlyCurrentPortfolio = false;
      that.includeOnlyCurrentOrganizations = false;
      that.suggestions = [];
      that.activeSuggestion = '';
    }
  });
}
